export const criteriaListSelector = (state) => state.criterias.list
export const criteriaPaginationSelector = (state) => state.criterias.pagination
export const selectedCriteriaSelector = (state) => state.criterias.selected
export const criteriaSearchSelector = (state) => state.criterias.search
export const criteriaPerPageSelector = (state) => state.criterias.per_page
